module.exports = __webpack_public_path__ + "img/table.8555995a.png";